export default "__VITE_ASSET__qUZLB8xF__"